import { IsEnum, IsObject, IsOptional, IsString, IsUUID } from 'class-validator';
import { UtmEventType } from '../../enums/utm-event-type.enum';

export class TrackUtmEventDto {
	@IsEnum(UtmEventType)
	event_type: UtmEventType;

	@IsOptional()
	@IsUUID()
	user_id?: string;

	@IsOptional()
	@IsString()
	utm_source?: string;

	@IsOptional()
	@IsString()
	utm_medium?: string;

	@IsOptional()
	@IsString()
	utm_campaign?: string;

	@IsOptional()
	@IsObject()
	metadata?: object;
}
